import { render, staticRenderFns } from "./SuccessSubmitForm2.vue?vue&type=template&id=1fd2214c&scoped=true"
import script from "./SuccessSubmitForm2.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2214c",
  null
  
)

export default component.exports